<template>
<div class="main-container">
    <div class="spinner" :style="styles"></div>
    <p class="text-center">Loading ...</p>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped>

.spinner {
    width: 40px;
    height: 40px;
    margin: 5px auto ;
    background-color: rgb(0, 38, 88);
    -webkit-animation: sk-rotateplane 1.2s infinite ease-in-out;
    animation: sk-rotateplane 1.2s infinite ease-in-out;
  }
  .main-container{
      position: absolute;
      padding: 40vh;
      width: 100%;
      background-color:black;
      height: 100vh !important;
      opacity: 0.9;
      overflow-y: hidden !important;
      
  }

  p{
      font-size: 14px!important;
  }
  @-webkit-keyframes sk-rotateplane {
    0% {
      -webkit-transform: perspective(120px)
    }
    50% {
      -webkit-transform: perspective(120px) rotateY(180deg)
    }
    100% {
      -webkit-transform: perspective(120px) rotateY(180deg) rotateX(180deg)
    }
  }
  @keyframes sk-rotateplane {
    0% {
      transform: perspective(120px) rotateX(0deg) rotateY(0deg);
      -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg)
    }
    50% {
      transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
      -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg)
    }
    100% {
      transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
      -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
    }
  }
</style>